"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxy = void 0;

var _regex = require("./regex");

const proxy = new Proxy(_regex.regex, {
  get(target, flags) {
    return target(flags === '_' ? '' : flags);
  },

  apply(target, _thisArg, args) {
    return target(...args);
  }

});
exports.proxy = proxy;